// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 280;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});
(function ($) {

    function waitForSlick(callback) {
        const interval = setInterval(function () {
            if (typeof $.fn.slick !== 'undefined') {
                clearInterval(interval);
                callback();
            }
        }, 100);
    }

    function initTestimonialSlider() {
        $('.testimonial-slider').each(function () {

            if ($(this).hasClass('slick-initialized')) return;

            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: true,
                adaptiveHeight: true,
                prevArrow: `
                    <button class="slick-prev" aria-label="Previous">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 10 20">
                            <path fill="#fff" fill-rule="evenodd"
                            d="M0.366 19.708c0.405 0.39 1.06 0.39 1.464 0l8.563-8.264a1.95 1.95 0 0 0 0-2.827L1.768 0.292A1.063 1.063 0 0 0 0.314 0.282a0.976 0.976 0 0 0-0.011 1.425l7.894 7.617a0.975 0.975 0 0 1 0 1.414L0.366 18.295a0.974 0.974 0 0 0 0 1.413"/>
                        </svg>
                    </button>`,
                nextArrow: `
                    <button class="slick-next" aria-label="Next">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 10 20">
                            <path fill="#fff" fill-rule="evenodd"
                            d="M0.366 19.708c0.405 0.39 1.06 0.39 1.464 0l8.563-8.264a1.95 1.95 0 0 0 0-2.827L1.768 0.292A1.063 1.063 0 0 0 0.314 0.282a0.976 0.976 0 0 0-0.011 1.425l7.894 7.617a0.975 0.975 0 0 1 0 1.414L0.366 18.295a0.974 0.974 0 0 0 0 1.413"/>
                        </svg>
                    </button>`,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: { slidesToShow: 1 }
                    }
                ]
            });
        });
    }

    function initInsightsSlider() {
        $('.insights-slider').each(function () {

            if ($(this).hasClass('slick-initialized')) return;

            $(this).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                prevArrow: $('.custom-latest-arrows .prev-arrow'),
                nextArrow: $('.custom-latest-arrows .next-arrow'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: 680,
                        settings: { slidesToShow: 1 }
                    }
                ]
            });
        });
    }

    window.addEventListener('load', function () {

        waitForSlick(function () {
            initTestimonialSlider();
            initInsightsSlider();
        });

    });

})(jQuery);
jQuery(document).ready(function($) {
    $('.js-slider-filter').each(function() {
        const $this = $(this);
        const sliderId = $this.data('slider-id');
        const allProducts = $this.data('all-products');
        const $output = $('#display-' + sliderId);
        const ajaxUrl = $this.closest('.filter-dropdown-area').data('ajax-url');

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_slider_slides',
                type: 0, 
                all_products: allProducts
            },
            beforeSend: function() { $output.css('opacity', '0.5'); },
            success: function(html) {
                $output.html(html).css('opacity', '1');

                $output.slick({
                    centerMode: true,
                    variableWidth: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    prevArrow: $('.slider-filter .custom-arrows .prev-arrow'),
                    nextArrow: $('.slider-filter .custom-arrows .next-arrow'),
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: { variableWidth: false, centerMode: false, slidesToShow: 2 }
                        },
                        {
                            breakpoint: 680,
                            settings: { variableWidth: false, centerMode: false, slidesToShow: 1 }
                        }
                    ]
                });
            }
        });

        $this.on('change', function() {
            const selectedValue = parseInt($(this).val(), 10);
            if (!selectedValue) return;

            const index = allProducts.indexOf(selectedValue);
            if (index >= 0) {
                $output.slick('slickGoTo', index);
            }
        });
    });
});
document.querySelectorAll('.filter-dropdown-area').forEach(wrapper => {
    const select = wrapper.querySelector('select');
    select.addEventListener('mousedown', () => {
        wrapper.classList.add('is-open');
    });
    select.addEventListener('change', () => {
        wrapper.classList.remove('is-open');
    });
    select.addEventListener('blur', () => {
        wrapper.classList.remove('is-open');
    });
    document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is-open');
        }
    });
});
(function(){

    function initChoices() {
        if (typeof window.Choices === 'undefined') {
            setTimeout(initChoices, 200);
            return;
        }

        document.querySelectorAll('.js-slider-filter').forEach(select => {

            if (select.classList.contains('choices-initialized')) return;

            new Choices(select, {
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: false,
                position: 'bottom',
            });

            select.classList.add('choices-initialized');
        });
    }

    window.addEventListener('load', function () {
        initChoices();
    });

})();



document.addEventListener('DOMContentLoaded', function() {
    const anchorLinksBlock = document.querySelector('.anchorlinks');
    if (!anchorLinksBlock) return;

    const buttons = anchorLinksBlock.querySelectorAll('.btn-site');

    const observerOptions = {
        root: null,
        rootMargin: '-280px 0px -70% 0px', 
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        let anyIntersecting = false;
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                anyIntersecting = true;
                const id = entry.target.getAttribute('id');
                buttons.forEach(btn => {
                    btn.classList.toggle('is-active', btn.getAttribute('href') === `#${id}`);
                });
            }
        });
        if (!anyIntersecting) {
            buttons.forEach(btn => btn.classList.remove('is-active'));
        }
    }, observerOptions);

    buttons.forEach(btn => {
        const href = btn.getAttribute('href');
        if (href && href.startsWith('#')) {
            const target = document.querySelector(href);
            if (target) observer.observe(target);
        }
    });
    const stopSection = document.querySelector('.stop-here');
    if (stopSection) {
        const stopOffset = stopSection.offsetTop + 10; 

        window.addEventListener('scroll', () => {
            if (window.scrollY >= stopOffset) {
                anchorLinksBlock.classList.add('is-hidden');
            } else {
                anchorLinksBlock.classList.remove('is-hidden');
            }
        });
    }
}); 
(function($){

    function initSliderCards() {

        if (typeof $.fn.slick === 'undefined') {
            setTimeout(initSliderCards, 200);
            return;
        }
        if ($('.slider-slides').hasClass('slick-initialized')) {
            return;
        }

        $('.slider-slides').on('init afterChange setPosition', function () {
            if (typeof AOS !== 'undefined') {
                AOS.refreshHard();
            }
        });

        $('.slider-slides').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            adaptiveHeight: true,
            infinite: false,
            useTransform: true,
            speed: 400,
            cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        });

        $('.slider-cards__nav')
            .on('init', function(event, slick) {
                $('.slider-cards__nav .slick-slide.slick-current').addClass('is-active');
            })
            .slick({
                slidesToShow: 4,
                slidesToScroll: 3,
                dots: false,
                arrows: false,
                focusOnSelect: false,
                infinite: false,
                responsive: [{
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }]
            });

        $('.slider-slides').on('afterChange', function (event, slick, currentSlide) {
            var $nav = $('.slider-cards__nav');
            var currentNavSlideElem =
                '.slider-cards__nav .slick-slide[data-slick-index="' + currentSlide + '"]';

            $nav.find('.slick-slide.is-active').removeClass('is-active');
            $(currentNavSlideElem).addClass('is-active');
            $nav.slick('slickGoTo', currentSlide);
        });

        $('.slider-cards__nav').on('click', '.slick-slide', function(event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');
            $('.slider-slides').slick('slickGoTo', goToSingleSlide);
        });
    }

    $(window).on('load', function () {
        initSliderCards();
    });

})(jQuery);